import { ApiProperty } from "@nestjs/swagger";

export class BrandsTrimsDTO{
    @ApiProperty()
    brandsTrimsId: number;
    @ApiProperty()
    masterBrandId:number;
    @ApiProperty()
    trimsId:number;
}